import { c as _c } from "react/compiler-runtime";
import CrushedIcon from "@catchy/assets/svgs/occupancy/occupancy-crushed.svg";
import EmptyIcon from "@catchy/assets/svgs/occupancy/occupancy-empty.svg";
import FewSeatsIcon from "@catchy/assets/svgs/occupancy/occupancy-few-seats.svg";
import FullIcon from "@catchy/assets/svgs/occupancy/occupancy-full.svg";
import SeatsAvailableIcon from "@catchy/assets/svgs/occupancy/occupancy-seats-available.svg";
import StandingIcon from "@catchy/assets/svgs/occupancy/occupancy-standing.svg";
const getOccupancyDetails = status => {
  switch (status) {
    case "EMPTY":
      return {
        description: "Empty",
        colorClass: "text-green-600 dark:text-green-400 opacity-50",
        IconComponent: EmptyIcon
      };
    case "MANY_SEATS_AVAILABLE":
      return {
        description: "Seats available",
        colorClass: "text-green-600 dark:text-green-400",
        IconComponent: SeatsAvailableIcon
      };
    case "FEW_SEATS_AVAILABLE":
      return {
        description: "Few seats available",
        colorClass: "text-amber-400 dark:text-amber-300",
        IconComponent: FewSeatsIcon
      };
    case "STANDING_ROOM_ONLY":
      return {
        description: "Standing room only",
        colorClass: "text-orange-400",
        IconComponent: StandingIcon
      };
    case "CRUSHED_STANDING_ROOM_ONLY":
      return {
        description: "Very limited standing room",
        colorClass: "text-rose-600/80 dark:text-rose-500/80",
        IconComponent: CrushedIcon
      };
    case "FULL":
      return {
        description: "Full. May not be accepting passengers",
        colorClass: "text-rose-600/80 dark:text-rose-500/80",
        IconComponent: FullIcon
      };
    case "NOT_ACCEPTING_PASSENGERS":
      return {
        description: "Not accepting passengers.",
        colorClass: "text-rose-600/80 dark:text-rose-500/80",
        IconComponent: FullIcon
      };
    case "NOT_BOARDABLE":
      return {
        description: "Not boardable.",
        colorClass: "text-rose-600/80 dark:text-rose-500/80",
        IconComponent: FullIcon
      };
    default:
      return null;
  }
};
export default function VehicleOccupancy(t0) {
  const $ = _c(11);
  const {
    status,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== status) {
    t2 = getOccupancyDetails(status);
    $[0] = status;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const details = t2;
  if (!details) {
    return null;
  }
  const IconComponent = details.IconComponent;
  const t3 = `flex min-h-7 items-center text-pretty transition-opacity duration-150 ${className}`;
  const t4 = `h-4 w-4 ${details.colorClass}`;
  let t5;
  if ($[2] !== IconComponent || $[3] !== t4) {
    t5 = <div className="mr-3 flex w-9 flex-shrink-0 justify-center"><IconComponent className={t4} /></div>;
    $[2] = IconComponent;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== details.description) {
    t6 = <div className="leading-tight">{details.description}</div>;
    $[5] = details.description;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t3 || $[8] !== t5 || $[9] !== t6) {
    t7 = <div className={t3}>{t5}{t6}</div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}